// De standaardbrief op de QR-pagina ('Brief maken'), voor elke organisatie.
//
// Teksten van Gijs, 2026-10-06: je-vorm, geen kop, geen getal voor de duur
// (blijft kloppen als de vragenlijst verandert). {{adresstap}} vult Letter.jsx
// alleen in als het onderzoek eerst om het adres vraagt (AskAddressFirst) —
// anders zou de brief een stap beloven die er niet is.
// De outputbrief (MomentKind 'output') hoort bij de QR-code van een
// registratieformulier: een medewerker of vrijwilliger registreert daarmee wat er
// bij een activiteit gedaan is. Keuze Gijs, 2026-10-20. De kop is de naam van de
// activiteit; zonder naam geen kop (Letter.jsx toont geen lege kop).
// De storytellingbrief (MomentKind 'storytelling') hoort bij de QR-code van een
// storytelling-deellink. Hij noemt niet wát je kunt insturen: dat verschilt per
// link (foto/video, quote, anekdote), en de pagina achter de code zegt het.
// Deccos kan per organisatie een EIGEN brief klaarzetten (LetterTemplates,
// functions/scripts/seedLetterTemplates.js); die staat dan bovenaan de lijst.
// AI-CONTEXT: See docs/features/adres-koppeling-algemene-qr.md

const QR_REGEL = 'Scan de QR-code met de camera van je telefoon.{{adresstap}}'

const DEFAULT_LETTER_TEMPLATES = [
    {
        ID: 'standaard__voor',
        TemplateKey: 'standaard',
        Label: 'Standaardbrief',
        MomentKind: 'voor',
        Title: '',
        Body: [
            'We willen graag laten zien hoe ons werk mensen helpt. Daar hebben we jouw hulp bij nodig. Met jouw antwoorden op deze vragenlijst help je ons te zien wat ons werk voor jullie en andere mensen betekent.',
            'Het invullen duurt maar een paar minuten. Er zijn geen goede of foute antwoorden. Vertel hoe het voor jou is. Je persoonlijke gegevens delen we nooit met anderen.',
            QR_REGEL,
            'Bedankt voor je hulp!',
        ].join('\n\n'),
    },
    {
        ID: 'standaard__na',
        TemplateKey: 'standaard',
        Label: 'Standaardbrief',
        MomentKind: 'na',
        Title: '',
        Body: [
            'Een tijdje geleden heb je onze vragenlijst ingevuld. Bedankt daarvoor! We willen graag weten hoe het nu met je gaat. Daarom vragen we je om nog een keer een vragenlijst in te vullen. Zo kunnen we zien wat er is veranderd en beter begrijpen wat ons werk voor jou en anderen betekent.',
            'Het invullen duurt maar een paar minuten. Er zijn geen goede of foute antwoorden. Vertel hoe het voor jou is, ook als er niets is veranderd of als het minder goed gaat. Je persoonlijke gegevens delen we nooit met anderen.',
            QR_REGEL,
            'Bedankt dat je ons opnieuw helpt!',
        ].join('\n\n'),
    },
    {
        ID: 'standaard__output',
        TemplateKey: 'standaard',
        Label: 'Standaardbrief',
        MomentKind: 'output',
        Title: '{{activiteit}}',
        Body: [
            'Met deze QR-code registreer je wat er bij deze activiteit is gedaan, bijvoorbeeld hoeveel mensen er waren. Zo kunnen we laten zien wat ons werk oplevert.',
            'Scan de QR-code met de camera van je telefoon en vul het formulier in na afloop van de activiteit, of op het moment dat met je is afgesproken. Je hoeft daarvoor niet in te loggen.',
            'Bedankt voor je hulp!',
        ].join('\n\n'),
    },
    {
        ID: 'standaard__storytelling',
        TemplateKey: 'standaard',
        Label: 'Standaardbrief',
        MomentKind: 'storytelling',
        Title: '',
        Body: [
            'We horen graag wat ons werk voor jou betekent. Een mooi moment, iets wat iemand zei of een kort verhaal: daarmee laten we zien wat er echt verandert.',
            'Scan de QR-code met de camera van je telefoon. Daar zie je wat je kunt insturen. Je hoeft daarvoor niet in te loggen.',
            'Bedankt voor je verhaal!',
        ].join('\n\n'),
    },
]

export default DEFAULT_LETTER_TEMPLATES
